import { createAction } from '@reduxjs/toolkit';

import { createRequest } from '../../services/request';

export const LOCATION_CHANGE = createRequest('LOCATION_CHANGE');
export const locationChange = createAction(LOCATION_CHANGE.BASE);
